import { render, staticRenderFns } from "./wsdifferenceCollect.vue?vue&type=template&id=6f1f2902&scoped=true"
import script from "./wsdifferenceCollect.vue?vue&type=script&lang=js"
export * from "./wsdifferenceCollect.vue?vue&type=script&lang=js"
import style0 from "./wsdifferenceCollect.vue?vue&type=style&index=0&id=6f1f2902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f2902",
  null
  
)

export default component.exports